<template>
  <div class="scroll-page">
    <Fixed :navFixed="navFixed"></Fixed>
    <div class="scroll-titleBox" id="scroll-titleBox">
      <p style="font-size:27px; line-height:200%; margin:0pt 0pt 10pt;text-align: center;"><a
          name="_055-1599121612466"></a><span
          style="font-size:27px; font-weight:bold">VoipServiceKit SDK合规使用指南</span></p>
    </div>
    <div class="scroll-contentBox">
      <p class="fontWeight-700" style="text-indent: 2em">
        如果您是开发者，在您接入、使用VoIP Service Kit
        SDK和服务前，您应在隐私政策中向用户告知本SDK的名称、提供方名称、收集个人信息类型、使用目的、隐私政策链接，并获取用户的同意或取得其他合法性基础。
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent0">
        一、声明SDK处理的个人信息
      </h2>
      <p class="p margin-l20 margin-b10">
        您可以参考如下方式进行声明：
      </p>
      <p class="p margin-l20 margin-b10">
        （1）文字方式：
      </p>
      <p class="p-small margin-l20 margin-b10">
        SDK名称：VoIP Service Kit SDK
      </p>
      <p class="p-small margin-l20 margin-b10">
        提供主体：玩咖欢聚信息技术（北京）有限公司
      </p>
      <p class="p-small margin-l20 margin-b10">
        使用目的：提供标准化的 VoIP 来电通话组件，实现通话样式和交互上的统一 。
      </p>
      <p class="p-small margin-l20 margin-b10">
        数据类型：应用基本信息（应用名称，应用包名，应用版本号，应用通话界面）、应用通话基本信息（通话ID、用户昵称、用户头像、通话类型信息），消息推送ID，系统基本信息（系统类型、系统版本）。
      </p>
      <p class="p-small margin-l20 margin-b10">
        隐私政策链接：<a class="color-blue" :href="ruleAddress">{{ruleAddress}}</a>
      </p>

      <p class="p margin-l20 margin-b10">
        （2）表格方式：
      </p>
      <table class="table">
        <tr>
          <th>SDK名称</th>
          <th>提供主体</th>
          <th>数据类型</th>
          <th>使用目的</th>
          <th>隐私政策链接</th>
        </tr>
        <tr>
          <td>VoIP Service Kit SDK</td>
          <td>玩咖欢聚信息技术（北京）有限公司</td>
          <td>
            应用基本信息（应用名称，应用包名，应用版本号，应用通话界面）、应用通话基本信息（通话ID、用户昵称、用户头像、通话类型信息），消息推送ID，系统基本信息（系统类型、系统版本）
          </td>
          <td>
            为用户提供VoIP通话的完整服务，在通话时显示来电用户的昵称，头像，通话类型，用户操作接听时能正常响应用户的操作，完成电话的接听，挂断。
          </td>
          <td>
            <a :href="ruleAddress" class="color-blue">{{ruleAddress}}</a>
          </td>
        </tr>
      </table>

      <h2 class="h2 margin-t30 margin-b20" id="navContent1">
        二、权限使用要求
      </h2>
      <p class="p margin-l20 margin-b10">
        VoIP Service Kit SDK在提供服务时不涉及系统权限的申请和使用。
      </p>

      <h2 class="h2 margin-t30 margin-b20" id="navContent2">
        三、SDK版本更新
      </h2>
      <p class="p margin-l20 margin-b10">
        为了提供最新的、安全的服务，我们会不时更新SDK版本。开发者可在金标联盟官网
        （<a
          class="color-blue"
          href="https://www.itgsa.com/home/union/openness"
      >https://www.itgsa.com/home/union/openness</a>
        ）下载最新版本的SDK并集成使用。
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent3">
        四、联系我们
      </h2>
      <p class="p margin-l20 margin-b10">
        如果您在使用VoIP Service Kit SDK的过程中遇到任何问题，可以通过金标联盟客服邮箱发送您的问题，我们会尽快为您解决。
      </p>
      <p class="p-small margin-l20 margin-b10">
        官方邮箱：<a href="mailto:service@itgsa.com" class="color-blue">service@itgsa.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import Fixed from "@/components/Fixed";

export default {
  components: {Fixed},
  data() {
    return {
      navFixed: [
        {
          name: '一、声明SDK处理的个人信息',
          isActive: 0,
          class: '#navContent0',
          child: []
        },
        {
          name: '二、权限使用要求',
          isActive: null,
          class: '#navContent1',
        },
        {
          name: '三、SDK版本更新',
          isActive: null,
          class: '#navContent2',
        },
        {
          name: '四、联系我们',
          isActive: null,
          class: '#navContent3',
        },
      ],
      ruleAddress: ''
    };
  },
  created() {
    // 根据当前不同环境显示不同的规则地址
    // 获取env的变量
    console.log(process.env.NODE_ENV);
    this.ruleAddress = process.env.NODE_ENV === 'production' ? 'https://www.itgsa.com/home/VoipServiceKit-rules' : 'http://test.itgsa.com/home/VoipServiceKit-rules';
  }
};
</script>

<style lang="scss" scoped>
.scroll-page {
  height: 100%;

  .scroll-titleBox {
    position: fixed;
    top: 64px;
    width: 100%;
    padding-top: 20px;
    border-bottom: 1px solid #dde2e8;
    background: #f8f6f7;
    z-index: 6;
  }

  .scroll-contentBox {
    width: calc(100% - 400px);
    border-left: 1px solid #dde2e8;
    padding: 2% 3% 2% 2%;
    margin-left: 300px;
    padding-top: 100px;

    .a-hover {
      color: #1a53ff;
    }

    .a-hover:hover {
      opacity: 0.7;
    }
  }
}

@media screen and (max-width: 800px) {
  .scroll-page {
    .scroll-titleBox {
      position: fixed;
      top: 120px;
      width: 100%;
      padding-top: 20px;
      border-bottom: 1px solid #dde2e8;
      background: #f8f6f7;
      z-index: 6;
    }

    .scroll-contentBox {
      box-sizing: border-box;
      width: 100%;
      padding: 120px 8% 2% 5%;
      border-left: 0;
      margin-top: 100px;
      margin-left: 0px;
    }
  }
}

.h1 {
  font-size: 32px;
  font-weight: bold;
}

.h2 {
  font-size: 20px;
  font-weight: bold;
}

.h3 {
  font-size: 18px;
  font-weight: bold;
}

.h4 {
  font-size: 17px;
  font-weight: bold;
}

.h5 {
  font-size: 16px;
  font-weight: bold;
}

.p {
  display: block;
  font-size: 15px;
  line-height: 28px;
}

.p-small {
  display: block;
  font-size: 13px;
  line-height: 24px;
}

.w400 {
  width: 400px;
}

.w600 {
  display: block;
  width: 600px;
}

.w750 {
  display: block;
  width: 750px;
}

.code {
  padding: 20px 40px;
  border: 1px solid #f29d1e;
  background-color: #ffffcc;
}

table {
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #000;
    padding: 10px;
  }
}

ul {
  li {
    list-style: disc;
  }
}
</style>

